import type { HttpClient } from '../client/http';
import type { DocResponse, ListResponse } from '../client/types';

export interface ListOpts {
  limit?: number;
  cursor?: string;
  orderBy?: 'created_at' | 'updated_at';
  order?: 'asc' | 'desc';
}

export interface CollectionMethods {
  /** @throws SdkError on network/5xx (retried 3x). */
  list(opts?: ListOpts): Promise<ListResponse>;
  /** @throws SdkError on network/5xx (NOT retried — fail-fast). @notIdempotent */
  create(args: { data: unknown }): Promise<DocResponse>;
  /** @throws SdkError on network/5xx (retried 3x). */
  read(docId: string): Promise<DocResponse>;
  /** @throws SdkError on network/5xx (NOT retried — fail-fast). @idempotent */
  update(docId: string, args: { data: unknown }): Promise<DocResponse>;
  /** @throws SdkError on network/5xx (NOT retried — fail-fast). @idempotent */
  delete(docId: string): Promise<void>;
}

export function createCollection(client: HttpClient, appId: string) {
  return function collection(name: string): CollectionMethods {
    const base = `/api/app/${appId}/db/${name}`;
    return {
      list(opts: ListOpts = {}): Promise<ListResponse> {
        const query: Record<string, string | number | undefined> = {
          limit: opts.limit ?? 50,
          orderBy: opts.orderBy ?? 'created_at',
          order: opts.order ?? 'desc',
        };
        if (opts.cursor) query.cursor = opts.cursor;
        return client.request<ListResponse>('GET', base, { query });
      },
      create(args) {
        return client.request<DocResponse>('POST', base, { body: args });
      },
      read(docId) {
        return client.request<DocResponse>('GET', `${base}/${docId}`);
      },
      update(docId, args) {
        return client.request<DocResponse>('PATCH', `${base}/${docId}`, { body: args });
      },
      delete(docId) {
        return client.request<void>('DELETE', `${base}/${docId}`);
      },
    };
  };
}
